export default {"src":"/_next/static/media/shade.106f3b13.svg","height":96,"width":116,"blurWidth":0,"blurHeight":0};